/**
 * Find the first ancestor matching with the selector
 * 
 * @param DomElement element The child
 * @param String selector The ancestor selector
 * 
 * @returns DomElement The first ancestor, null if not found
 */
window.findAncestor = function(element, selector) {
  while (element) {
      if (element.matches(selector)) {
        return element;
      }
      element = element.parentElement;
  }

  return null;
}


window.findSiblings = function(element, selector)
{
  const parent = element.parentNode;

  const selectedSiblings = Array.from(parent.children).filter(child => 
      child !== element && child.matches(selector)
  );

  return selectedSiblings;
}
